<template>
  <v-layout
    class="add-new-account"
    row
    justify-center>
    <v-dialog
      v-model="accountDialog.show"
      persistent
      scrollable
      
    >
      <v-card>
        <span
          class="close-dialog-btn"
          @click="closeDialog">X</span>
        <v-card-title v-if="accountDialog.type === 'new'">
          Create New Account <span v-if="accountDialog.selectedCustomer">&nbsp;under <span class="font-weight-bold">{{ accountDialog.fields.Customer_Name + ' ' + accountDialog.fields.Customer_Region }}</span> </span>
        </v-card-title>
        <v-card-title v-else-if="accountDialog.type === 'view'">
          Viewing {{ accountDialog.fields.Acct_name }}
        </v-card-title>
        <v-card-title v-else-if="accountDialog.type === 'edit'">
          Edit {{ accountDialog.fields.Acct_name }}
          <v-chip

            class="ma-2"
            color="primary"
            text-color="white"
            pill
            @click="validateAccountDetails()"
          >
            Validate Account's from Orgs Master<v-avatar small><v-icon
              small
              right>mdi-account-check</v-icon></v-avatar>
          </v-chip>
        </v-card-title>
        <v-divider/>
        <v-card-text
          v-if="accountDialog.showSelectCustomer"
          style="height: 600px;">
          <v-container fluid>
            <v-layout column>
              <v-flex xs12>
                <div
                  class="resultContainer"
                  style="height: 300px;">
                  <v-layout
                    align-center
                    justify-center
                    row
                    fill-height>
                    <v-toolbar
                      light
                    >
                      <v-toolbar-title>Select Customer</v-toolbar-title>
                      <v-autocomplete
                        v-model="accountDialog.selectedCustomer"
                        :loading="accountDialog.searchLoading"
                        :items="accountDialog.customerList"
                        :search-input.sync="search"
                        item-text="Cust_Region"
                        item-value="Customer_Id"
                        cache-items
                        class="mx-3"
                        flat
                        hide-no-data
                        hide-details
                        label="Create Account under what Customer?"
                        solo-inverted
                        attach
                        style="z-index:999"
                        light
                        no-data-text="No results found"
                        @change="onCustomerSelected"
                      />
                      <v-btn
                        :disabled="accountDialog.continueEnabled"
                        color="orange"
                        @click="onSelectCustomer">
                        Continue
                      </v-btn>
                    </v-toolbar>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text
          v-else
          style="height: 600px; position: relative">
          <div
            v-if="accountDialog.saving"
            class="account-overlay">
            <v-layout
              align-center
              justify-center
              row
              fill-height >
              <v-progress-circular
                indeterminate
                color="primary"
              />
              &nbsp;Saving
            </v-layout>
          </div>
          <div
            v-if="accountDialog.saved"
            class="account-overlay">
            <v-layout
              align-center
              justify-center
              row
              fill-height >
              <v-alert
                :value="accountDialog.saved"
                :type="accountDialog.alertType"
              >
                {{ accountDialog.alertMessage }}
              </v-alert>
            </v-layout>
          </div>
          
            <v-stepper
              v-model="accountDialog.step"
              non-linear>
              <v-stepper-header>
                <v-stepper-step
                  :color="stepOneInvalid ? 'error' : 'success'"
                  :complete="accountDialog.step > 1"
                  :edit-icon="stepOneInvalid ? 'clear' : 'done'"
                  editable
                  step="1">General</v-stepper-step>

                <v-divider/>

                <v-stepper-step
                  :complete="accountDialog.step > 2"
                  editable
                  step="2"
                  edit-icon="check">Customer</v-stepper-step>

                <v-divider/>

                <v-stepper-step
                  :complete="accountDialog.step > 3"
                  editable
                  step="3"
                  edit-icon="check">Agreements</v-stepper-step>

                <v-divider/>

                <v-stepper-step
                  :complete="accountDialog.step > 4"
                  editable
                  step="4"
                  edit-icon="check">Financial</v-stepper-step>

                <v-divider/>

                <!-- <v-stepper-step :complete="accountDialog.step > 4" step="4">Account Expiration</v-stepper-step> -->
                <v-stepper-step
                  :color="stepFiveInvalid ? 'error' : 'success'"
                  :complete="accountDialog.step > 5"
                  :edit-icon="stepFiveInvalid ? 'clear' : 'done'"
                  editable
                  step="5">Security</v-stepper-step>
                <v-divider/>

                <v-stepper-step
                v-if="['edit','view'].includes(accountDialog.type)"
                  :color="stepSixInvalid ? 'error' : 'success'"
                  :complete="accountDialog.step > 6"
                  :edit-icon="stepSixInvalid ? 'clear' : 'done'"
                  editable
                  step="6">Contacts</v-stepper-step>
                <v-divider v-if="['edit','view'].includes(accountDialog.type)"/>

                <v-stepper-step
                  :complete="accountDialog.step > 7"
                  editable
                  step="7"
                  edit-icon="check">Comments</v-stepper-step>
                <v-divider v-if="['edit','view'].includes(accountDialog.type)"/>

                <v-stepper-step
                  v-if="['edit','view'].includes(accountDialog.type)"
                  editable
                  step="8"
                  edit-icon="check">AWS/APN</v-stepper-step>

              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-form
                    ref="generalForm"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-text-field
                      v-model.trim="accountDialog.fields.Acct_ID"
                      :counter="12"
                      :error="accountDialog.accountIdExistError"
                      :error-messages="accountDialog.accountIdExistErrorMessages"
                      :success="accountDialog.accountIdExistSuccess"
                      :success-messages="accountDialog.accountIdExistSuccessMessages"
                      :loading="accountDialog.accountIdExistLoading"
                      :readonly="['edit','view'].includes(accountDialog.type)"
                      @change="checkIfAccountIdIsAvailable"
                    >
                      <template slot="label"> <span v-html="`Account ID <span class='required'>*</span>`"/></template>

                    </v-text-field>

                    <v-autocomplete
                      v-model="accountDialog.fields.Master_Id"
                      :readonly="isRecordView"
                      :items="masterPayers"
                      :search-input.sync="searchMP"
                      item-text="MP_Name"
                      item-value="Master_Id"
                      flat
                      hide-no-data
                      hide-details
                      label="Master Payer"
                      style="z-index:999"
                      no-data-text="No results found"
                      @change="onMasterPayerChange"
                    />

                    <v-text-field
                      v-validate="accountDialog.validatePrevMpId ? 'required' : ''"
                      v-model="accountDialog.fields.Previous_MP_ID"
                      :error-messages="errors.collect('Previous_MP_ID')"
                      :readonly="isRecordView"
                      :disabled="checkFieldPerm()"
                      data-vv-name="Previous_MP_ID"
                      data-vv-validate-on="blur"
                      label="Previous MP ID"
                    />
                     <v-text-field 
                      label="OppReg Id" 
                      v-model="accountDialog.fields.OppReg_Id"
                      :readonly="isRecordView"
                      :disabled="OppRegIdIsEnabled() && accountDialog.type ==='edit' "
                      :error = "accountDialog.OppRegIdExistError"
                      :error-messages = "accountDialog.OppRegIdExistErrorMessage"
                      :success = "accountDialog.OppRegIdExistSuccess"
                      :success-messages = "accountDialog.OppRegIdExistSuccessMessage">
                       <template v-slot:append>
                        <v-btn class="my-0" small 
                        v-if= "accountDialog.OppregIdStatus === false "
                        :loading ="accountDialog.OppRegIdExistLoading" 
                        @click="checkOppregId">
                         <span v-if="accountDialog.OppregIdValidated === false && accountDialog.OppRegIdExistSuccess === false">validate</span>
                        <v-icon
                          v-if="accountDialog.OppregIdValidated === true && accountDialog.OppRegIdExistSuccess === true"
                          small>check</v-icon>
                        </v-btn>
                       </template> 
                      </v-text-field>

                      <!-- <v-text-field 
                      label="Opportunity Number" 
                      v-model="accountDialog.fields.OppReg_Id"
                      :disabled="OppNumberIdIsEnabled() && accountDialog.type ==='edit' "
                      :error = "accountDialog.OppNumberExistError"
                      :error-messages = "accountDialog.OppNumberExistErrorMessage"
                      :success = "accountDialog.OppNumberExistSuccess"
                      :success-messages = "accountDialog.OppNumberExistSuccessMessage">
                       <template v-slot:append>
                        <v-btn class="my-0" small 
                        v-if= "accountDialog.OppNumber === false "
                        :loading ="accountDialog.OppNumberExistLoading" 
                        @click="checkOppNumber">
                         <span v-if="accountDialog.OppNumberValidated === false && accountDialog.OppNumberExistSuccess === false">validate</span>
                        <v-icon
                          v-if="accountDialog.OppNumberValidated === true && accountDialog.OppNumberExistSuccess === true"
                          small>check</v-icon>
                        </v-btn>
                       </template> 
                      </v-text-field> -->
                    <v-autocomplete
                      label="Choose a Workload"
                      :readonly="isRecordView"
                      v-model="accountDialog.fields.Project_Id"
                      v-if= "accountDialog.isWorkload === true"
                      :items="filterWorkloads"
                      item-text="Workload_Title"
                      item-value="Project_Id"
                    ></v-autocomplete>
                    <v-text-field
                      v-validate="'required'"
                      :readonly="isRecordView"
                      v-model="accountDialog.fields.Acct_name"
                      :error-messages="errors.collect('Acct_name')"
                      data-vv-name="Acct_name"
                      data-vv-validate-on="blur"
                    >
                      <template slot="label"> <span v-html="`Account Name <span class='required'>*</span>`"/></template>
                    </v-text-field>
                    <v-select
                      v-validate="'required'"
                      :readonly="isRecordView"
                      :items="['ACTIVE','SUSPENDED','Moved to Client', 'Active - Not in Use']"
                      :error-messages="errors.collect('Acct_Status')"
                      v-model="accountDialog.fields.Acct_Status"
                      :disabled="checkFieldPerm()"
                      attach
                      data-vv-name="Acct_Status"
                      data-vv-validate-on="blur"
                      label="Account Status"
                      @change="onAcctStatusChange"
                    />
                    <v-menu
                      v-if="accountDialog.fields.Acct_Status === 'SUSPENDED'"
                      :disabled="isRecordView"
                      v-model="accountDialog.dates.date_suspended"
                      :close-on-content-click="false"
                      lazy
                      transition="scale-transition"
                      full-width
                      min-width="290px"
                    >
                      <template 
                        v-slot:activator="{ on }">
                        <v-text-field
                          v-validate="'date_format:yyyy-MM-dd'"
                          v-model="accountDialog.fields.Date_Suspended"
                          :error-messages="errors.collect('Date_Suspended')"
                          readonly
                          data-vv-name="Date_Suspended"
                          data-vv-validate-on="blur"
                          v-on="on"
                        >
                          <template slot="label"> <span v-html="`Date Suspended <span class='required'>*</span>`"/></template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateSuspended"
                        @input="accountDialog.dates.date_suspended = false"/>
                    </v-menu>

                    <v-text-field
                      :readonly="isRecordView"
                      v-model="accountDialog.fields.Acct_Alias_Group"
                      :error-messages="errors.collect('Acct_Alias_Group')"
                      data-vv-name="Acct_Alias_Group"
                      data-vv-validate-on="blur"
                    >
                      <template slot="label"> <span v-html="`Account Group`"/></template>
                    </v-text-field>

                    <v-select
                      :readonly="isRecordView"
                      :items="['Build (ODT)','ORR','CloudOps']"
                      v-model="accountDialog.fields.Acct_Offering_Stat"
                      :disabled="checkFieldPerm()"
                      attach
                      label="Account Offering Status"
                    />
                    <v-text-field
                      :readonly="isRecordView"
                      v-validate="'required|email'"
                      v-model="accountDialog.fields.Acct_DL"
                      :error-messages="errors.collect('Acct_DL')"
                      data-vv-name="Acct_DL"
                      data-vv-validate-on="blur"
                    >
                      <template slot="label"> <span v-html="`Account DL <span class='required'>*</span>`"/></template>
                    </v-text-field>

                    <v-menu
                      :disabled="isRecordView"
                      v-model="accountDialog.dates.date_onboarded"
                      :close-on-content-click="false"
                      lazy
                      transition="scale-transition"
                      full-width
                      min-width="290px"
                    >
                      <template 
                        v-slot:activator="{ on }">
                        <v-text-field
                          v-validate="'date_format:yyyy-MM-dd'"
                          v-model="accountDialog.fields.Date_onboarded"
                          :error-messages="errors.collect('Date_onboarded')"
                          readonly
                          data-vv-name="Date_onboarded"
                          data-vv-validate-on="blur"
                          v-on="on"
                        >
                          <template slot="label"> <span v-html="`Date Onboarded <span class='required'>*</span>`"/></template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateOnboarded"
                        @input="accountDialog.dates.date_onboarded = false"/>
                    </v-menu>
                    <v-menu
                      :disabled="isRecordView"
                      v-model="accountDialog.dates.last_date_validated"
                      :close-on-content-click="false"
                      lazy
                      transition="scale-transition"
                      full-width
                      min-width="290px"

                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-validate="'date_format:yyyy-MM-dd'"
                          v-model="accountDialog.fields.Last_Date_Validated"
                          :error-messages="errors.collect('Last_Date_Validated')"
                          :disabled="checkFieldPerm()"
                          readonly
                          data-vv-name="Last_Date_Validated"
                          data-vv-validate-on="blur"
                          v-on="on"
                        >
                          <template v-slot:append>
                            <v-chip
                              class="ma-2"
                            >
                              <span>
                                {{ (accountDialog.fields.Validation_Type === 'API') ? "Validation update via API": "Update via Galaxy Application." }}<v-avatar small><v-icon
                                  right
                                  small>mdi-cloud-check</v-icon></v-avatar>
                              </span>
                            </v-chip>
                          </template>
                          <template slot="label"> <span v-html="`Last_Date_Validated <span class='required'>*</span>`"/></template>

                        </v-text-field>

                      </template>
                      <v-date-picker
                        v-model="dateValidated"
                        @input="accountDialog.dates.last_date_validated = false"/>
                    </v-menu>
                    <v-select
                      :readonly="isRecordView"
                      v-validate="'required'"
                      :items="['DXC Gold','DXC Silver','AMS (AWS Managed Services)','None']"
                      :error-messages="errors.collect('Managed_Svc')"
                      v-model="accountDialog.fields.Managed_Svc"
                      :disabled="checkFieldPerm()"
                      attach
                      data-vv-name="Managed_Svc"
                      data-vv-validate-on="blur"
                    >
                      <template slot="label"> <span v-html="`Managed Svc <span class='required'>*</span>`"/></template>

                      <template v-slot:append>
                        <v-select
                          :readonly="isRecordView"
                          v-if="$can('manage', 'admin') && accountDialog.fields.Managed_Svc === 'DXC Gold'"
                          :items="pods"
                          v-model="accountDialog.fields.FG_Name"
                          class="hide-underline"
                          :menu-props="{ top: true, offsetY: true, }"
                          item-text="FG_Name"
                          attach
                          @change="updatePodId"

                        >
                          <template slot="label"> <span v-html="`POD Name`"/></template>
                        </v-select>

                      </template>

                    </v-select>

                    <v-select
                      :readonly="isRecordView"
                      v-validate="'required'"
                      :items="['Enterprise','Business','Developer','Basic']"
                      :error-messages="errors.collect('AWS_Support_Type')"
                      v-model="accountDialog.fields.AWS_Support_Type"
                      :menu-props="{ top: true, offsetY: true }"
                      attach
                      data-vv-name="AWS_Support_Type"
                      data-vv-validate-on="blur"
                    >
                      <template slot="label"> <span v-html="`AWS Support Type <span class='required'>*</span>`"/></template>
                    </v-select>

                    <v-text-field
                      :readonly="isRecordView"
                      v-model="accountDialog.fields.GovCloud_Resource_Account"
                      :error-messages="errors.collect('GovCloud_Resource_Account')"
                      data-vv-name="GovCloud_Resource_Account"
                      data-vv-validate-on="blur"
                    >
                      <template slot="label"><span v-html="`GovCloud Resource Account`"/></template>
                    </v-text-field>

                    <v-switch
                      :readonly="isRecordView"
                      v-model="dateOnboardLock"
                      :label="`Is Date Onboard Lock`"
                    />

                    <v-switch
                      :readonly="isRecordView"
                      v-if="$can('write', 'inventory')"
                      v-model="customerOwned"
                      label="Customer Owned?"
                    />

                    <v-switch
                      :readonly="isRecordView"
                      v-if="$can('write', 'inventory')"
                      v-model="accountRestricted"
                      :label="`Account Restricted?`"
                    />
                    <!-- <v-switch
                      v-else
                      v-model="accountDialog.fields.Acct_Restricted"
                      :label="`Account Restricted? (readonly)`"
                      readonly
                      value="Yes" /> -->
                      <!-- <v-switch
                      v-model="accountDialog.fields.Is_MP"
                      :label="`Is this a Master Payer? (readonly)`"
                      readonly
                      value="Yes" /> -->

                    <v-switch
                      :readonly="isRecordView"
                      v-if="$can('write', 'inventory')"
                      v-model="isMasterPayer"
                      :label="`Is this a Master Payer?`"
                    />

                  </v-form>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-form
                    ref="CustomerDetailsForm"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-autocomplete
                      :readonly="isRecordView"
                      v-model="accountDialog.fields.Customer_Id"
                      :loading="accountDialog.searchLoading"
                      :items="customers"
                      :search-input.sync="search"
                      :disabled="checkFieldPerm()"
                      item-text="Cust_Region"
                      item-value="Customer_Id"
                      flat
                      hide-no-data
                      hide-details
                      label="Customer"
                      style="z-index:999"
                      no-data-text="No results found"
                      @change="onCustomerSelectedChange"
                    />
                    <v-text-field
                      :readonly="isRecordView"
                      v-if="accountDialog.type === 'edit'"
                      v-model="accountDialog.fields.Customer_Alias_Group"
                      :disabled="checkFieldPerm()"
                      label="Customer Alias Group"/>
                    <v-text-field
                      :readonly="isRecordView"
                      v-model="accountDialog.fields.Customer_Region"
                      :disabled="checkFieldPerm()"
                      label="Customer Region"
                      readonly/>

                    <v-text-field
                      :readonly="isRecordView"
                      v-model="accountDialog.fields.Cloudability_Customer_Instance"
                      :disabled="checkFieldPerm()"
                      label="Cloudability Customer Instance"
                    />

                    <v-divider />
                    <div
                      class="justify-end"
                      style="text-align: right;">
                      <v-btn @click="onCreateNewAndAssign">Create New &amp; Assign</v-btn>
                    </div>

                  </v-form>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-form
                    ref="uniqueAgreementsForm"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-text-field
                      :readonly="isRecordView"
                      v-validate="'between:0,100'"
                      v-model="accountDialog.fields.DXC_discount"
                      :error-messages="errors.collect('DXC_discount')"
                      :disabled="checkFieldPerm()"
                      type="number"
                      data-vv-name="DXC_discount"
                      data-vv-validate-on="blur"
                      label="DXC Discount" />
                    <v-text-field
                      :readonly="isRecordView"
                      v-validate="'between:0,100'"
                      v-model="accountDialog.fields.Client_discount"
                      :error-messages="errors.collect('Client_discount')"
                      :disabled="checkFieldPerm()"
                      type="text"
                      data-vv-name="Client_discount"
                      data-vv-validate-on="blur"
                      label="Client Discount %" />
                    <v-text-field
                      :readonly="isRecordView"
                      v-validate="'between:0,100'"
                      v-model="accountDialog.fields.Client_uplift"
                      :error-messages="errors.collect('Client_uplift')"
                      :disabled="checkFieldPerm()"
                      type="text"
                      data-vv-name="Client_uplift"
                      data-vv-validate-on="blur"
                      label="Client Uplift %" />
                  </v-form>
                </v-stepper-content>

                <v-stepper-content step="4">
                  <v-form
                    ref="FinancialForm"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-text-field
                      :readonly="isRecordView"
                      v-model="accountDialog.fields.WBS_code"
                      :disabled="checkFieldPerm()"
                      label="WBS Code" />
                    <v-menu
                      v-model="accountDialog.dates.wbs_expiration_date"
                      :close-on-content-click="false"
                      lazy
                      transition="scale-transition"
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-validate="'date_format:yyyy-MM-dd'"
                          v-model="accountDialog.fields.WBS_expiration_date"
                          :disabled="checkFieldPerm()"
                          v-on="on"
                          label="WBS Expiration Date"
                          attach
                          :error-messages="errors.collect('Date_onboarded')"
                          data-vv-name="WBS_expiration_date"
                          data-vv-validate-on="blur"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="WBSExpirationDate"
                        @input="accountDialog.dates.wbs_expiration_date = false"/>
                    </v-menu>

                    <v-text-field
                      :readonly="isRecordView"
                      v-model="accountDialog.fields.IWO_Code"
                      :disabled="checkFieldPerm()"
                      label="IWO Code" />

                    <v-select
                      :readonly="isRecordView"
                      :items="businessSegmentList"
                      v-model="business_segment"
                      data-vv-name="Business_Segment"
                      data-vv-validate-on="blur"
                      label="Business Segment"
                    />
                    <v-text-field
                      v-validate="business_segment === 'Other'? 'required' : ''"
                      v-if="business_segment === 'Other'"
                      v-model="otherBusinessSegment"
                      :error-messages="errors.collect('Other_Business_Segment')"
                      data-vv-name="Other_Business_Segment"
                      data-vv-validate-on="blur">
                      <template slot="label"> <span v-html="`Enter Other Business Segment <span class='required'>*</span>`"/></template>
                    </v-text-field>

                    <v-select
                      :readonly="isRecordView"
                      :items="businessProductLineList"
                      v-model="business_product_line"
                      data-vv-name="Business_Product_Line"
                      data-vv-validate-on="blur"
                      label="Business Product Line"
                    />
                    <v-text-field
                      v-validate="business_product_line === 'Other'? 'required' : ''"
                      v-if="business_product_line === 'Other'"
                      v-model="otherBusinessProductLine"
                      :error-messages="errors.collect('Other_Business_Product_Line')"
                      data-vv-name="Other_Business_Product_Line"
                      data-vv-validate-on="blur">
                      <template slot="label"> <span v-html="`Enter Other Business Product Line <span class='required'>*</span>`"/></template>
                    </v-text-field>

                  </v-form>
                </v-stepper-content>

                <v-stepper-content step="5">
                  <v-form
                    ref="AcctExpirationForm"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-select
                      :readonly="isRecordView"
                      :items="mfaList"
                      v-model="mfa"
                      data-vv-name="MFA"
                      data-vv-validate-on="blur"
                      label="MFA"
                    />
                    <v-text-field
                      v-validate="mfa === 'Other' || !mfaList.includes(mfa) ? 'required' : ''"
                      v-if="mfa === 'Other' || !mfaList.includes(mfa)"
                      v-model="otherMFA"
                      :error-messages="errors.collect('Other_MFA')"
                      data-vv-name="Other_MFA"
                      data-vv-validate-on="blur">
                      <template slot="label"> <span v-html="`Other <span class='required'>*</span>`"/></template>
                    </v-text-field>
                    <v-select
                      :readonly="isRecordView"
                      :items="rcsList"
                      v-model="rootCredentialStore"
                      :error-messages="errors.collect('Root_Credential_Store')"
                      data-vv-name="Root_Credential_Store"
                      data-vv-validate-on="blur"
                      label="Root Credential Store"
                    />
                    <v-text-field
                      :readonly="isRecordView"
                      v-validate="rootCredentialStore === 'Other' || !rcsList.includes(rootCredentialStore) ? 'required' : ''"
                      v-if="rootCredentialStore === 'Other' || !rcsList.includes(rootCredentialStore)"
                      v-model="otherRootCredentialStore"
                      :error-messages="errors.collect('Other_Root_Credential_Store')"
                      data-vv-name="Other_Root_Credential_Store"
                      data-vv-validate-on="blur">
                      <template slot="label"> <span v-html="`Other <span class='required'>*</span>`"/></template>
                    </v-text-field>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content step="6">
                  <v-form
                    ref="Contacts"
                    v-model="valid"
                    lazy-validation
                  >
                  <template>
                    &nbsp;
                  </template>
                  <template>
                    <v-text-field
                      :readonly="true"
                      v-model="accountDialog.fields.Requestor_Email"
                      label="Requestor Email"
                    />
                    <div class="d-flex align-center justify-space-between mb-3">
                      <p class="v-label v-label--active theme--light v-ao mb-0">Who are the account owners of the AWS account? &nbsp;
                        <v-btn
                          v-if="!isRecordView"
                          small
                          color="orange"
                          @click="addAccountOwner"
                          class="ml-3"
                        >
                          Add Account Owner
                        </v-btn>
                      </p>
                    </div>
                    <p class="empty-owners" v-if="!accountDialog.fields.Account_Owners || accountDialog.fields.Account_Owners.length === 0">No Account Owners defined</p>
                    <div v-if="accountDialog.fields.Account_Owners && accountDialog.fields.Account_Owners.length > 0" class="account-owners-list">
                      <div class="owner-chips-container">
                        <div v-for="(owner, index) in accountDialog.fields.Account_Owners" :key="index" class="owner-items">
                          <v-chip class="ma-1" outlined>
                            <span class="owner-name">{{ owner.name }}</span>
                            <span class="owner-email">&nbsp;|&nbsp;{{ owner.email }}</span>
                            <v-icon v-if="!isRecordView" small class="ml-2" @click.stop="toggleEditForm(index)">edit</v-icon>
                          </v-chip>
                          <!-- <v-icon v-if="!isRecordView" small class="ml-2" @click="deleteItem(owner)">delete</v-icon> -->
                        </div>
                      </div>
                      
                      <v-expand-transition>
                        <div v-if="editingIndex !== null" class="owner-edit-form mt-3">
                          <v-text-field 
                            dense 
                            v-model.trim="editingOwner.name" 
                            label="Name"
                            class="mb-2"
                          />
                          <v-text-field 
                            dense 
                            v-model.trim="editingOwner.email" 
                            label="Email"
                            class="mb-2"
                          />
                          <v-text-field 
                            dense 
                            v-model.trim="editingOwner.phone" 
                            label="Phone"
                            class="mb-2"
                          />
                          <div class="edit-form-actions">
                            <v-btn small color="orange" @click="saveEditedOwner(editingIndex)" class="mr-2">{{ editingIndex === -1 ? 'Add' : 'Save' }}</v-btn>
                            <v-btn small @click="cancelEditForm">Cancel</v-btn>
                          </div>
                        </div>
                      </v-expand-transition>
                    </div>
                    <v-expand-transition>
                      <div v-if="editingIndex === -1 && (!accountDialog.fields.Account_Owners || accountDialog.fields.Account_Owners.length === 0)" class="owner-edit-form mt-3">
                        <v-text-field 
                          dense 
                          v-model.trim="editingOwner.name" 
                          label="Name"
                          class="mb-2"
                        />
                        <v-text-field 
                          dense 
                          v-model.trim="editingOwner.email" 
                          label="Email"
                          class="mb-2"
                        />
                        <v-text-field 
                          dense 
                          v-model.trim="editingOwner.phone" 
                          label="Phone"
                          class="mb-2"
                        />
                        <div class="edit-form-actions">
                          <v-btn small color="orange" @click="saveEditedOwner(editingIndex)" class="mr-2">Add</v-btn>
                          <v-btn small @click="cancelEditForm">Cancel</v-btn>
                        </div>
                      </div>
                    </v-expand-transition>
                    
                  </template>
                    <template>
                      <v-combobox 
                        :readonly="isRecordView"
                        v-model="accountDialog.fields.Notification_List"
                        label="List of users who will receive notifications from AWS on account usage"
                        chips
                        clearable
                        :rules="emailRules"
                        multiple>
                          <template v-slot:selection="data">
                              <v-chip :selected="data.selected"
                                      close
                                      @input="notificationListRemove(data.item)">
                                  <strong>{{ data.item }}</strong>&nbsp;
                              </v-chip>
                          </template>
                      </v-combobox>
                    </template>
                    <template>
                        <v-combobox 
                          :readonly="isRecordView"
                          v-model="accountDialog.fields.IAM_Users"
                          label="List of users for the account who need Admin access"
                          chips
                          clearable
                          :rules="emailRules"
                          multiple>
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected"
                                        close
                                        @input="iAmUsersRemove(data.item)">
                                    <strong>{{ data.item }}</strong>&nbsp;
                                </v-chip>
                            </template>
                        </v-combobox>
                    </template>
                    <template>
                        <v-combobox
                          :readonly="isRecordView"
                          v-model="accountDialog.fields.Financial_Owner"
                          label="Who is the financial owner of the AWS account (owner of WBS / IWO associated with it)?"
                          chips
                          clearable
                          :rules="emailRules"
                          multiple>
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected"
                                        close
                                        @input="financeOwnersRemove(data.item)">
                                    <strong>{{ data.item }}</strong>&nbsp;
                                </v-chip>
                            </template>
                        </v-combobox>
                    </template>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content step="7">
                  <v-form
                    ref="Comments"
                    v-model="valid"
                    lazy-validation
                  >

                    <v-textarea
                      :readonly="isRecordView"
                      v-model="accountDialog.fields.Comments"
                      :value="''"
                      clearable
                      label="Comments" />
                  </v-form>
                </v-stepper-content>

                <v-stepper-content step="8" v-if="['edit','view'].includes(accountDialog.type)">
                  <v-form>                    
                    <v-text-field
                      :readonly="isRecordView"
                      ref="aceOppNumber"
                      @focus="aceOppNumberisFocus = true"
                      @blur="aceOppNumberisFocus = false"
                      v-model.trim="accountDialog.fields.ACE_Opportunity_Number"
                      :error="accountDialog.opportunityNumberExistError"
                      :error-messages="accountDialog.opportunityNumberExistErrorMessages"
                      :success="accountDialog.opportunityNumberExistSuccess"
                      :success-messages="accountDialog.opportunityNumberExistSuccessMessages"
                      :loading="accountDialog.opportunityNumberExistLoading"
                      :messages="accountDialog.opportunityNumberExistLoadingMessages"
                      label="ACE Opportunity Number"
                      placeholder="ACE Opportunity Number"
                      @change="checkIfOpportunityNumberIsAvailable"/>
                    <v-select
                      :readonly="isRecordView"
                      :items="['AWS End User', 'AWS Internal']"
                      v-model="accountDialog.fields.AWS_Usage_Type"
                      attach
                      label="AWS Usage Type"
                    />

                    <label class="aws-field-label">AWS Government Customer</label>
                    <v-radio-group
                      :readonly="isRecordView"
                      v-model="accountDialog.fields.AWS_Government_Customer"
                      row >
                      <v-radio
                        color="orange"
                        label="Yes"
                        value="Yes"/>
                      <v-radio
                        color="orange"
                        label="No"
                        value="No"/>
                    </v-radio-group>


                    <label class="aws-field-label">AWS Advising Government</label>
                    <v-radio-group
                      :readonly="isRecordView"
                      v-model="accountDialog.fields.AWS_Advising_Government"
                      row >
                      <v-radio
                        color="orange"
                        label="Yes"
                        value="Yes"/>
                      <v-radio
                        color="orange"
                        label="No"
                        value="No"/>
                    </v-radio-group>


                    <v-menu
                      :disabled="isRecordView"
                      v-model="accountDialog.dates.aws_launch_date"
                      :close-on-content-click="false"
                      lazy
                      transition="scale-transition"
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="AWSLaunchDate"
                          :disabled="checkFieldPerm() || isRecordView"
                          v-on="on"
                          label="AWS EUR Date"
                          attach
                        >
                          <!-- <template v-slot:append>
                            <v-btn
                              :loading="accountDialog.savingAWSLaunchDate"
                              :disabled="accountDialog.savingAWSLaunchDate"
                              color="orange"
                              class="my-0"
                              small
                              @click="onAWSLaunchDateSave"
                            >
                              <span>SAVE</span>
                            </v-btn>
                          </template> -->
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="AWSLaunchDate"
                        @input="accountDialog.dates.aws_launch_date = false"/>
                    </v-menu>


                    <v-menu
                      :disabled="isRecordView"
                      v-model="accountDialog.dates.date_sent_to_aws"
                      :close-on-content-click="false"
                      lazy
                      transition="scale-transition"
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateSentToAWS"
                          :disabled="checkFieldPerm() || isRecordView"
                          v-on="on"
                          label="AWS ACE Launch Date"
                          attach
                        >
                          <!-- <template v-slot:append>
                            <v-btn
                              :loading="accountDialog.savingDateSentToAWS"
                              :disabled="accountDialog.savingDateSentToAWS"
                              color="orange"
                              class="my-0"
                              small
                              @click="onDateSentToAWS"
                            >
                              <span>SAVE</span>
                            </v-btn>
                          </template> -->
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateSentToAWS"
                        @input="accountDialog.dates.date_sent_to_aws = false"/>
                    </v-menu>
                  </v-form>

                </v-stepper-content>

              </v-stepper-items>
            </v-stepper>
          
        </v-card-text>
        <v-divider/>
        <v-card-actions >
          <v-btn
            v-if="accountDialog.step > 1"
            :disabled="errors.items.length ? true : false || accountDialog.saving || accountDialog.saved"
            @click="onPreviousStep"
          >
            Previous
          </v-btn>
          <v-btn
            v-if="accountDialog.step < 7 && !accountDialog.showSelectCustomer"
            :disabled="checkForFieldErrors()"
            color="orange"
            @click="accountDialog.step++"
          >
            Continue
          </v-btn>
          <v-spacer/>
          <div
            v-if="$can('write', 'inventory') && !isRecordView">
            <v-btn
              v-if="accountDialog.step == 7 && !accountDialog.saved"
              :disabled="checkForFieldErrors()"
              :loading="accountDialog.saving"
              color="orange"
              @click="accountDialog.submitHandler(accountDialog.fields)">{{ accountDialog.submitLabel }}</v-btn>

            <v-btn
              :disabled="accountDialog.opportunityNumberExistError || accountDialog.opportunityNumberExistLoading"
              v-if="accountDialog.step == 8 && !accountDialog.saved"
              :loading="accountDialog.saving"
              color="orange"
              @click="saveAWSAPNData">Update AWS/APN Data</v-btn>
          </div>
          <v-btn
            :disabled="accountDialog.saving"
            @click.stop="onCancel">{{ accountDialog.cancelLabel }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      newOwner: {
        name: '',
        email: '',
        phone: ''
      },
      editingIndex: null,
      editingOwner: {
        name: '',
        email: '',
        phone: ''
      },
      valid: null,
      step: 1,
      search: null,
      searchMP: null,
      aceOppNumberisFocus: false,
      aceOppNumberChange: false,
      businessSegmentList: ['GIS', 'Insurance', 'Consulting & Engineering Services', 'DXC IT', 'Other'],
      businessProductLineList: ['Security', 'Modern Workplace', 'Cloud Infrastructure & ITO', 'Custom Applications', 'Horizontal BPS', 'Insurance', 'Consulting & Engineering Services', 'Other'],
      mfaList: ['Vault0', 'Vault0eu', 'Vault0us', 'KeePass AU (KeeOTP)', 'KeePass US (KeeOTP) - Legacy', 'KeePass EU (KeeOTP) - Legacy', 'Authy (MP)', 'Authy (Child) - Legacy', 'Hardware key (acct owner)', 'None', 'Other'],
      rcsList: ['Vault0', 'Vault0eu', 'Vault0us', 'KeePass Global (Legacy)', 'KeePass AU', 'KeePass US - Legacy', 'KeePass EU - Legacy', 'KeePass (MP)', 'None', 'Other'],
      emailRules :[
      v => {
        if (v.length > 0) {
          for (let i = 0; i < v.length; i++) {
                if (!(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v[i]))) {
                return 'Input must be valid email format';
              }
            }
          }
        else return true;
      }
      ]
    }
  },
  computed: {
    ...mapState('admin/accountInventory', ['masterPayers', 'pods']),
    ...mapState('admin', ['customers', 'accountDialog']),

    customerOwned: {
      get: function () {
         return this.accountDialog.fields.Customer_Owned === 'Yes'
       },
       set: function (customerOwned) {
          this.accountDialog.fields.Customer_Owned = customerOwned ? 'Yes' : 'No'
       }
    },

    accountRestricted: {
       get: function () {
         return this.accountDialog.fields.Acct_Restricted === 'Yes'
       },
       set: function (accountRestricted) {
          this.accountDialog.fields.Acct_Restricted = accountRestricted ? 'Yes' : 'No'
       }
    },

    isMasterPayer: {
      get: function () {
        return this.accountDialog.fields.Is_MP === 'Yes'
      },
      set: function (isMasterPayer) {
        this.accountDialog.fields.Is_MP = isMasterPayer ? 'Yes' : 'No'
      }
    },

    getStep() {
      return this.accountDialog.step
    },

    isRecordView() {
      return this.accountDialog.type === 'view'
    },
    dateOnboardLock: {
      get: function () {
        return this.accountDialog.fields.Onboard_Date_Lock === 'Y'
      },
      set: function (dateOnboardLock) {
        this.accountDialog.fields.Onboard_Date_Lock = dateOnboardLock ? 'Y' : 'N'
        console.log('Set Date Onboard Lock: ' + this.accountDialog.fields.Onboard_Date_Lock)
      }
    },
    dateSuspended: {
      get: function () {
        return (this.accountDialog.fields.Date_Suspended !== '0000-00-00' && this.accountDialog.fields.Date_Suspended !== 'None')
          ? this.accountDialog.fields.Date_Suspended
          : ''
      },
      set: function (dateSuspended) {
        this.accountDialog.fields.Date_Suspended = dateSuspended ? dateSuspended : 'None'
      }
    },
    dateOnboarded: {
      get: function () {
        return this.accountDialog.fields.Date_onboarded !== '0000-00-00' ? this.accountDialog.fields.Date_onboarded : ''
      },
      set: function (dateOnboarded) {
        this.accountDialog.fields.Date_onboarded = dateOnboarded
      }
    },
    dateValidated: {
      get: function () {
        return this.accountDialog.fields.Last_Date_Validated !== '0000-00-00' ? this.accountDialog.fields.Date_onboarded : ''
      },
      set: function (dateValidated) {
        this.accountDialog.fields.Last_Date_Validated = dateValidated
      }
    },

    AWSLaunchDate: {
      get: function () {
        console.log(this.accountDialog.fields.AWS_EUR_Date)
        return this.accountDialog.fields.AWS_EUR_Date !== '0000-00-00' && this.accountDialog.fields.AWS_EUR_Date !== 'None' ? this.accountDialog.fields.AWS_EUR_Date : ''
      },
      set: function (date) {
        console.log(date)
        this.accountDialog.fields.AWS_EUR_Date = date
      }
    },

    WBSExpirationDate: {
      get: function () {
        return this.accountDialog.fields.WBS_expiration_date !== '0000-00-00' && this.accountDialog.fields.WBS_expiration_date !== 'None' ? this.accountDialog.fields.WBS_expiration_date : ''
      },
      set: function (date) {
        this.accountDialog.fields.WBS_expiration_date = date
      }
    },

    dateSentToAWS: {
      get: function () {
        return this.accountDialog.fields.AWS_ACE_Launch_Date !== '0000-00-00' && this.accountDialog.fields.AWS_ACE_Launch_Date !== 'None' ? this.accountDialog.fields.AWS_ACE_Launch_Date : ''
      },
      set: function (date) {
        this.accountDialog.fields.AWS_ACE_Launch_Date = date
      }
    },

    business_segment: {
      get: function () {
        return this.businessSegmentList.includes(this.accountDialog.fields.Business_Segment) ? this.accountDialog.fields.Business_Segment : ''
      },
      set: function (businessSegment) {
        this.accountDialog.fields.Business_Segment = businessSegment
        if (businessSegment !== 'Other') {
          this.otherBusinessSegment = ''
        }
      }
    },

    business_product_line: {
      get: function () {
        return this.businessProductLineList.includes(this.accountDialog.fields.Business_Product_Line) ? this.accountDialog.fields.Business_Product_Line : ''
      },
      set: function (businessProductLine) {
        this.accountDialog.fields.Business_Product_Line = businessProductLine
        if (businessProductLine !== 'Other') {
          this.otherBusinessProductLine = ''
        }
      }
    },
    otherBusinessSegment: {
      get: function () {
        return this.accountDialog.fields.Business_Segment_Other && this.accountDialog.fields.Business_Segment_Other !== 'None' ? this.accountDialog.fields.Business_Segment_Other : ''
      },
      set: function (businessSegment) {
        this.accountDialog.fields.Business_Segment_Other = businessSegment
      }
    },
    otherBusinessProductLine: {
      get: function () {
        return this.accountDialog.fields.Business_Product_Line_Other && this.accountDialog.fields.Business_Product_Line_Other !== 'None' ? this.accountDialog.fields.Business_Product_Line_Other : ''
      },
      set: function (businessProductLine) {
        this.accountDialog.fields.Business_Product_Line_Other = businessProductLine
      }
    },

    mfa: {
      get: function () {
        return this.mfaList.includes(this.accountDialog.fields.MFA) ? this.accountDialog.fields.MFA : 'Other'
      },
      set: function (mfa) {
        this.accountDialog.fields.MFA = mfa
      }
    },
    otherMFA: {
      get: function () {
        return !this.mfaList.includes(this.accountDialog.fields.MFA) ? this.accountDialog.fields.MFA : ''
      },
      set: function (mfa) {
        this.accountDialog.fields.MFA = mfa
      }
    },
    rootCredentialStore: {
      get: function () {
        return this.rcsList.includes(this.accountDialog.fields.Root_Credential_Store) ? this.accountDialog.fields.Root_Credential_Store : 'Other'
      },
      set: function (rcs) {
        this.accountDialog.fields.Root_Credential_Store = rcs
      }
    },
    otherRootCredentialStore: {
      get: function () {
        return !this.rcsList.includes(this.accountDialog.fields.Root_Credential_Store) ? this.accountDialog.fields.Root_Credential_Store : ''
      },
      set: function (rcs) {
        this.accountDialog.fields.Root_Credential_Store = rcs
      }
    },
    customerList () {
      if (this.accountDialog.type === 'edit') {
        return this.customers ? this.customers : [{
          Customer_Id: this.accountDialog.fields.Customer_Id,
          Customer_Name: this.accountDialog.fields.Customer_Name,
          Customer_Region: this.accountDialog.fields.Customer_Region
        }]
      } else {
        return this.customers
      }
    },
    stepOneInvalid () {
      let value = !!((!this.accountDialog.accountIdExist) || (!this.accountDialog.fields.Acct_ID) ||
      !this.accountDialog.fields.Acct_name ||
      !this.accountDialog.fields.Acct_DL ||
      !this.accountDialog.fields.Date_onboarded ||
      !this.accountDialog.fields.Last_Date_Validated ||
      !['Enterprise', 'Business', 'Developer', 'Basic'].includes(this.accountDialog.fields.AWS_Support_Type) ||
      !['DXC Gold', 'DXC Silver', 'AMS (AWS Managed Services)', 'None'].includes(this.accountDialog.fields.Managed_Svc) ||
      this.errors.items.length)
      return value
    },
    stepTwoInvalid () {
      return !!this.errors.items.length
    },
    stepThreeInvalid () {
      return !!this.errors.items.length
    },
    stepFourInvalid () {
      return !!this.errors.items.length
    },
    stepFiveInvalid () {
        if (this.accountDialog.fields.MFA === 'Other' || !this.mfaList.includes(this.accountDialog.fields.MFA)) {
          if (!this.otherMFA) {
            return true
          }
        }
        if (this.accountDialog.fields.Root_Credential_Store === 'Other' || !this.rcsList.includes(this.accountDialog.fields.Root_Credential_Store)) {
          if (!this.otherRootCredentialStore) {
            return true
          }
        }
      return !!this.errors.items.length
    },
    stepSixInvalid () {
      if (!this.emailRulesFN(this.accountDialog.fields.Notification_List)
      || !this.emailRulesFN(this.accountDialog.fields.Account_Owners)
      || !this.emailRulesFN(this.accountDialog.fields.IAM_Users)
      || !this.emailRulesFN(this.accountDialog.fields.Financial_Owner)) {
        return true
      }
      return !!this.errors.items.length
    },
    filterWorkloads(){
      let workloadStatus = [
        'AWS Reg Accepted', 
        'Approved - Tier 1 23% - PPA', 
        'Approved - Tier 1 23% - PPA SaaS', 
        'Approved - Tier 3 12%',
        'Approved - Tier 2 - Custom EDP',
        'LEGACY - Approved - Tier 1 23% - PPA',
        'LEGACY - Approved - Tier 1 23% - PPA SaaS',
        'LEGACY - Approved - Tier 3 12%',
        'LEGACY - Approved - Tier 2 - Custom EDP'
      ]
      return this.accountDialog.workloads.filter(workload => workloadStatus.includes(workload.Workload_Status)) 
    }
  },
  watch: {
    search (val) {
      val && val !== this.accountDialog.selectedCustomer && this.searchCustomer(val)
    }
    ,
    'accountDialog.fields.Account_Owners': {
      handler () {
        this.normalizeAccountOwners()
      },
      deep: true
    }
  },

  methods: {
    onCancel () {
      if (this.accountDialog.fields.Acct_ID && !this.accountDialog.saved) {
        this.$store.commit('showDialog', {
          show: true,
          type: 'confirmation',
          persistent: true,
          title: 'You will lose your work when you cancel',
          yesLabel: 'Cancel',
          yesHandler: () => {
            this.$store.commit('showDialog', { show: false })
            this.$store.commit('admin/resetAccountDialog')
            this.$store.commit('admin/clearValidationErrors')
          },
          noHandler: () => {
            this.$store.commit('showDialog', { show: false })
          },
          noLabel: 'No'
        }, { root: true })
      } else {
        if (this.accountDialog.closeHandler) {
          this.accountDialog.closeHandler(this.accountDialog.fields.Acct_ID)
        }

        this.$store.commit('admin/resetAccountDialog')
        this.$store.commit('admin/clearValidationErrors')
      }
    },
    onPreviousStep (step) {
      this.accountDialog.step = this.accountDialog.step - 1
    },
    searchCustomer (searchItem) {
      this.$store.dispatch('admin/searchCustomers', searchItem)
    },
    onSelectCustomer () {
      if (this.accountDialog.selectedCustomer && this.accountDialog.selectedCustomer !== 'None') {
        this.accountDialog.showSelectCustomer = false
        this.accountDialog.fields.Ext_Account_Id = this.accountDialog.selectedCustomer
      }
    },
    checkIfAccountIdIsAvailable () {
      this.$store.dispatch('admin/checkIfAccountIdIsAvailable', this.accountDialog.fields.Acct_ID, { root: true })
    },

    checkIfOpportunityNumberIsAvailable () {
      this.accountDialog.opportunityNumberExistLoadingMessages = 'Checking for existing value'
      if (this.accountDialog.fields.ACE_Opportunity_Number) {
        this.aceOppNumberChange = true
        this.$store.dispatch('admin/checkIfOpportunityNumberIsAvailable', this.accountDialog.fields.ACE_Opportunity_Number, { root: true })
      } else {
        this.$store.commit('admin/clearAceOppNumChecking')
        this.aceOppNumberChange = false
      }
    },
    onMasterPayerChange (val) {
      // if (this.$store.state.admin.accountDialog.type === 'edit') {
      this.accountDialog.validatePrevMpId = true
      this.accountDialog.fields.Previous_MP_ID = this.accountDialog.fields.MP_ID
      // }
    },
    onEditCustomer () {
      this.$store.commit('admin/clearCustomerDialog')
      this.$store.commit('admin/openCustomerDialog', {
        show: true,
        type: 'edit',
        fields: {
          Customer_Id: this.accountDialog.fields.Customer_Id,
          Customer_Name: this.accountDialog.fields.Customer_Name,
          Customer_Region: this.accountDialog.fields.Customer_Region,
          Customer_Alias: this.accountDialog.fields.Customer_Alias
        },
        submitLabel: 'Update',
        submitHandler: (customer) => {
          console.log('Updating customer with values: ', customer)
          this.$store.dispatch('admin/updateCustomer', customer, function (id) {
            this.$store.commit('admin/updateCustomer', id)
          })
        }
      })
    },
    updatePodId: function (name) {
      let pod = this.pods.find(pod => pod.FG_Name === name)
      this.$store.commit('admin/assignPODId', pod.Id)
    },

    // onOtherMFASet (mfa) {
    //   debugger
    //   this.accountDialog.fields.MFA = mfa
    // },

    onCustomerSelectedChange (id) {
      this.$store.commit('admin/updateCustomer', id)
    },
    // onMasterPayerChange (id) {
    //   // this.$store.commit('admin/updateCustomer', id)
    // },
    onCreateNewAndAssign () {
      this.$store.commit('admin/clearCustomerDialog')
      this.$store.commit('admin/openCustomerDialog', {
        show: true,
        type: 'new',
        submitLabel: 'Create New and Assign',
        submitHandler: (customer) => {
          console.log('1329 Creating new customer with values: ', customer)
          this.$store.dispatch('admin/saveNewCustomerAndAssign', customer)
        }
      })
    },
    onCustomerSelected (id) {
      this.accountDialog.continueEnabled = false
      this.$store.commit('admin/setNewCustomerData', this.accountDialog.selectedCustomer)
    },
    checkFieldPerm () {
      return this.$store.state.viewCustomFields.isAllowed
    },
    validateAccountDetails () {
      this.$store.dispatch('admin/accountInventory/validateAccountDetails', this.accountDialog.fields)
    },
    onAcctStatusChange (status) {
      if (status === 'SUSPENDED') {
        this.$store.commit('admin/updateDateSuspended', new Date().toISOString().substr(0, 10))
      } else {
        this.$store.commit('admin/updateDateSuspended', 'None')
      }
    },

    OppRegIdIsEnabled() {

      if(this.accountDialog.fields.OppReg_Id === 'None') {
        this.accountDialog.OppregIdStatus = false
        return this.accountDialog.OppregIdStatus 
      } else {
        return this.accountDialog.OppregIdStatus
      } 
    },

    checkOppregId() {
      this.$store.dispatch('admin/validateOppregId', this.accountDialog.fields.OppReg_Id)
    },

    // onAWSLaunchDateSave() {
    //   this.$store.dispatch('admin/updateAccountAWSLaunchDate', { Onboarding_Id: this.accountDialog.fields.Onboarding_Id, AWS_EUR_Date: this.AWSLaunchDate})
    // },

    // onDateSentToAWS() {
    //   this.$store.dispatch('admin/updateAccountDateSentToAWS', { Onboarding_Id: this.accountDialog.fields.Onboarding_Id, AWS_ACE_Launch_Date: this.dateSentToAWS})
    // },
    closeDialog () {
      this.$store.commit('admin/openAccountDialog', { show: false })
      this.$store.commit('admin/resetAccountDialog')
      this.$store.commit('admin/clearValidationErrors')
    },

    saveAWSAPNData() {
      console.log('saving aws/apn data')
      let awsFields = {
        Onboarding_Id: this.accountDialog.fields.Onboarding_Id,
        AWS_EUR_Date: this.AWSLaunchDate,
        AWS_ACE_Launch_Date: this.dateSentToAWS,
        AWS_Usage_Type: this.accountDialog.fields.AWS_Usage_Type,
        AWS_Government_Customer: this.accountDialog.fields.AWS_Government_Customer,
        AWS_Advising_Government: this. accountDialog.fields.AWS_Advising_Government
      }

      if (this.accountDialog.fields.ACE_Opportunity_Number && this.aceOppNumberChange && this.accountDialog.fields.ACE_Opportunity_Number != 'None') {
        awsFields = {
          ...awsFields,
          ACE_Opportunity_Number: this.accountDialog.fields.ACE_Opportunity_Number
        }
      }
      this.$store.dispatch('admin/updateAccountAWSAPNData', awsFields)
    },

    accountOwnersRemove(item) {
      this.accountDialog.fields.Account_Owners.splice(this.accountDialog.fields.Account_Owners.indexOf(item), 1)
      this.accountDialog.fields.Account_Owners = [...this.accountDialog.fields.Account_Owners]
    },

    notificationListRemove(item) {
      this.accountDialog.fields.Notification_List.splice(this.accountDialog.fields.Notification_List.indexOf(item), 1)
      this.accountDialog.fields.Notification_List = [...this.accountDialog.fields.Notification_List]
    },
    iAmUsersRemove(item) {
      this.accountDialog.fields.IAM_Users.splice(this.accountDialog.fields.IAM_Users.indexOf(item), 1)
      this.accountDialog.fields.IAM_Users = [...this.accountDialog.fields.IAM_Users]
    },
    financeOwnersRemove(item) {
      this.accountDialog.fields.Financial_Owner.splice(this.accountDialog.fields.Financial_Owner.indexOf(item), 1)
      this.accountDialog.fields.Financial_Owner = [...this.accountDialog.fields.Financial_Owner]
    },


    emailRulesFN (email) {
      let errorCounter = 0
        if (email.length > 0) {
          for (let i = 0; i < email.length; i++) {
                if (!(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(email[i]))) {
                errorCounter += 1
              }
            }
            if (errorCounter > 0) return false
            return true
          }
        else return true;
    },
    checkForFieldErrors () {
      if (this.accountDialog.type === 'edit') return false
      if (this.getStep == 1) return this.stepOneInvalid
      if (this.getStep == 5) return this.stepFiveInvalid
      if (this.getStep == 6) return this.stepSixInvalid
      if (this.getStep == 7) {
        if (this.stepOneInvalid || (this.stepFiveInvalid) || this.stepSixInvalid) {
          return true
        } else return false
      }
    },
    formatAccountOwner (accountOwner) {
      if (!accountOwner) return []
      if (Array.isArray(accountOwner)) return accountOwner.map(item => `${item.name} (${item.email})`)
       return [`${accountOwner.name} (${accountOwner.email})`]
    }
    ,
    normalizeAccountOwners() {
      try {
        let owners = this.accountDialog.fields.Account_Owners
        if (!owners) {
          this.$set(this.accountDialog.fields, 'Account_Owners', [])
          return
        }
        if (Array.isArray(owners)) return
        if (typeof owners === 'string') {
          try {
            const parsed = JSON.parse(owners)
            if (Array.isArray(parsed)) {
              this.$set(this.accountDialog.fields, 'Account_Owners', parsed)
              return
            }
          } catch (e) {
          }
        }
        if (typeof owners === 'object') {
          this.$set(this.accountDialog.fields, 'Account_Owners', [owners])
          return
        }
        this.$set(this.accountDialog.fields, 'Account_Owners', [])
      } catch (e) {
        this.$set(this.accountDialog.fields, 'Account_Owners', [])
      }
    },
    deleteItem(item) {
      const owners = this.accountDialog.fields.Account_Owners || []
      const idx = owners.indexOf(item)
      if (idx > -1) {
        owners.splice(idx, 1)
        this.accountDialog.fields.Account_Owners = [...owners]
      }
    },
    toggleEditForm(index) {
      const owner = this.accountDialog.fields.Account_Owners[index]
      this.editingIndex = index
      this.editingOwner = {
        name: owner.name || '',
        email: owner.email || '',
        phone: owner.phone || ''
      }
    },
    addAccountOwner() {
      this.editingIndex = -1
      this.editingOwner = { name: '', email: '', phone: '' }
    },
    saveEditedOwner(index) {
      const updated = { 
        name: this.editingOwner.name.trim(), 
        email: this.editingOwner.email.trim(), 
        phone: this.editingOwner.phone.trim() 
      }
      if (index === -1) {
        // Adding new owner
        const owners = this.accountDialog.fields.Account_Owners || []
        this.accountDialog.fields.Account_Owners = [...owners, updated]
      } else {
        // Editing existing owner
        this.$set(this.accountDialog.fields.Account_Owners, index, updated)
        this.accountDialog.fields.Account_Owners = [...this.accountDialog.fields.Account_Owners]
      }
      this.editingIndex = null
      this.editingOwner = { name: '', email: '', phone: '' }
    },
    cancelEditForm() {
      this.editingIndex = null
      this.editingOwner = { name: '', email: '', phone: '' }
    },
    addOwner() {
      console.log('Adding owner:', this.newOwner.name)
      // if (this.isRecordView) return
      const name = (this.newOwner.name || '').trim()
      const email = (this.newOwner.email || '').trim()
      const phone = (this.newOwner.phone || '').trim() || null
      console.log('New owner details:', { name, email, phone })
      // if (!name) {
      //   return this.$root.$emit('show-snackbar', { message: 'Owner name is required', color: 'error' })
      // }
      // if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      //   return this.$root.$emit('show-snackbar', { message: 'Owner email is invalid', color: 'error' })
      // }
      console.log('Validated owner details')
      const owners = this.accountDialog.fields.Account_Owners || []
      console.log('Existing owners:', owners)
      const owner = { name, email, phone }
      this.accountDialog.fields.Account_Owners = [...owners, owner]
      console.log('Current owners:', this.accountDialog.fields.Account_Owners)
      this.newOwner = { name: '', email: '', phone: '' }
    },
  },
  mounted() {
    this.$store.dispatch('admin/getAllCustomers', {})
    this.normalizeAccountOwners()
  },
}
</script>
<style lang="scss">
  .add-new-account {
    .theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused>.v-input__control>.v-input__slot {
      background: #7e7e7e;
    }
  }

  .account-overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 5;
  }

  .hide-underline.v-text-field>.v-input__control>.v-input__slot:before {
    border-style: none;
  }

  .close-dialog-btn {
    position: absolute;
    right: 15px;
    top: 10px;
    cursor: pointer;
    font-size: 20px;
  }
  .v-ao {
    font-size: 16px!important;
    font-weight: 500;
  }
  .v-ao-add .v-text-field__slot .v-label{
    color: rgba(0, 0, 0, .54)!important;
  }

  .aws-field-label {
    font-weight: 400;
    font-size: 12px;
    color: #383838;
  }

  .v-stepper__header {
    flex-wrap: nowrap !important;
    overflow: auto;
  }
  .empty-owners {
    font-style: italic;
    color: #757575;
    padding-bottom: 17px;
  }

  .account-owners-list {
    margin: 20px 0;
  }
  .owner-chips-container {
    padding: 12px;
    margin-bottom: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background-color: #fafafa;
    display: flex;
    // flex-direction: row;
    // align-items: center;
    // justify-content: space-between;
  }
  .owner-item {

  }

  .owner-info {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .owner-name {
    font-weight: 500;
    font-size: 14px;
    color: #333;
  }

  .owner-email {
    font-size: 12px;
    color: #666;
  }

  .owner-edit-form {
    padding: 12px;
    border: 1px solid #e0e0e0;
    margin-top: 12px;
    border-radius: 4px;
    background-color: #f2ecec;
  }

  .edit-form-actions {
    display: flex;
    gap: 8px;
    margin-top: 12px;
  }

  .owner-info .v-icon {
    cursor: pointer;
    transition: color 0.2s;
  }

  .owner-info .v-icon:hover {
    color: #ff9800;
  }</style>
